module.exports = __webpack_public_path__ + "static/img/service.6da9adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/service.png
// module id = 6Dod
// module chunks = 1